import {Component, ElementRef, HostListener, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {distanceMeters, getBearing, getCenterAndZoom} from "./map-utils";
import {Position, Round, RoundSettings} from "../model/round";

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.css']
})
export class MapComponent implements OnChanges {
    private map: any | null = null

    mapFrameHeight: number = 0;
    mapEventsEnabled: boolean = false;
    translate: string = "";
    rotate: string = "";

    // @ts-ignore
    @Input() settings: RoundSettings
    @Input() holeIndex: number = 0

    // @ts-ignore
    @ViewChild("mapContainer") container: ElementRef;

    // @ts-ignore
    @ViewChild("defaultMap")
    set mapFrame(value: ElementRef) {
        this.map = value.nativeElement.contentWindow;
        setTimeout(() => {
            this.updateTranslation()
            this.update()
        })
    }

    @HostListener('window:resize')
    onResize() {
        this.updateTranslation();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update()
    }

    zoomIn() {
        this.setZoom(1);
    }

    zoomOut() {
        this.setZoom(-1);
    }

    private updateTranslation() {
        const cw = this.container.nativeElement.offsetWidth;
        const ch = this.container.nativeElement.offsetHeight;
        if (!cw || !ch) {
            return;
        }
        this.mapFrameHeight = 1.5 * cw;
        this.translate = 'translate(-25%,' + (-1.5 * cw + ch) / 2 + 'px)';
    }

    private setZoom(diff: number) {
        this.map?.setZoom(diff);
    }

    update() {
        const hole = this.settings.course.holes[this.holeIndex];
        const hasData = hole && hole.tee && hole.greenMiddle;
        if (!hasData) {
            return;
        }

        const data: MapData = {
            tee: hole.tee,
            green: hole.greenMiddle,
            shots: [],
            angle: getBearing(hole.tee, hole.greenMiddle)
        };

        this.updateRotation(-data.angle + 90);
        this.setMapData(data);
    }

    private setMapData(data: MapData) {
        const that = this
        if (!this.map) {
            return
        }
        if (this.map.setData) {
            // noinspection TypeScriptValidateJSTypes
            this.map.setData(data, distanceMeters, getCenterAndZoom);
        } else {
            // @ts-ignore
            window.onMapLoaded = function () {
                // noinspection TypeScriptValidateJSTypes
                that.map.setData(data, distanceMeters, getCenterAndZoom);
            };
        }
    }

    updateRotation(angle: number) {
        this.rotate = 'rotate(' + angle + 'deg)';
    }
}

interface MapData {
    tee: Position
    green: Position
    shots: any[]
    angle: number
}

